export var VaultUserServiceEvent;
(function (VaultUserServiceEvent) {
    VaultUserServiceEvent["UsersChanged"] = "VaultUserServiceEvent.UsersChanged";
    VaultUserServiceEvent["InvalidatedAllUserCache"] = "VaultUserServiceEvent.InvalidatedUserCache";
    VaultUserServiceEvent["InvalidatedUserCacheForVault"] = "VaultUserServiceEvent.InvalidatedUserCacheForVault";
})(VaultUserServiceEvent || (VaultUserServiceEvent = {}));
